import { render, staticRenderFns } from "./ZoneTableCard.vue?vue&type=template&id=5af19638"
import script from "./ZoneTableCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ZoneTableCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports